import { DOCUMENT, Injectable, inject } from '@angular/core';

import { SPRITE_VERSION } from './sprite-version';

/**
 * Fetches the generated icon sprite (assets/icons/sprite.svg) once and injects
 * it into <body>, so <use href="#icon-name"> refs resolve against in-document
 * symbols. Inlining (rather than referencing sprite.svg#id by URL) is what lets
 * `currentColor` work — cross-document <use> drops it in several browsers.
 */
@Injectable({ providedIn: 'root' })
export class IconRegistry {
  private readonly document = inject(DOCUMENT);
  private loaded = false;

  async load(): Promise<void> {
    if (this.loaded) {
      return;
    }
    this.loaded = true;

    // ?v=<content hash> busts CDN/browser caches on icon changes; the file
    // itself is served with a stable name and immutable caching (nginx.conf).
    const res = await fetch(`assets/icons/sprite.svg?v=${SPRITE_VERSION}`);
    if (!res.ok) {
      console.error(`[IconRegistry] failed to load sprite: ${res.status}`);
      return;
    }
    const markup = await res.text();

    const holder = this.document.createElement('div');
    // The sprite's root <svg> is display:none; this wrapper just parks it.
    holder.style.display = 'none';
    holder.setAttribute('aria-hidden', 'true');
    holder.innerHTML = markup;
    this.document.body.prepend(holder);
  }
}
